import { Star, StarEmpty, StarHalf } from './ReviewStars';

export const renderStars = (rating: number) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
        if (rating >= i) {
            stars.push(<Star key={i} />);
        } else if (rating >= i - 0.5) {
            stars.push(<StarHalf key={i} />);
        } else {
            stars.push(<StarEmpty key={i} />);
        }
    }
    return stars;
};
